<div class="messages-container">
  @for (message of messages(); track message.messageId) {
  <dc-chat-message [chatMessage]="message" [chatUserSettings]="chatUserSettings()"> </dc-chat-message>
  } @if (isThinking()) {
  <div class="thinking-container">
    <div class="thinking-message">
      <div class="thinking-avatar">
        <img [src]="aiIcon" alt="AI thinking" class="avatar-img" />
      </div>
      <div class="thinking-content">
        <p-skeleton width="80%" height="2rem"></p-skeleton>
        <p-skeleton width="60%" height="2rem"></p-skeleton>
      </div>
    </div>
  </div>
  }
</div>
